import accountSagas from 'data/accounts/sagas';
import accountDiscoverySagas from 'components/Dialogs/AccountDiscovery/sagas';
import authSagas from 'utils/auth/sagas';
import budgetsSagas from 'data/budgets/budgetsSagas';
import budgetItemsSagas from 'data/budgetItems/budgetItemsSagas';
import categorySagas from 'data/categories/sagas';
import categoryGroupsSagas from 'data/categoryGroups/categoryGroupsSagas';
import categoryGroupListsSagas from 'data/categoryGroupLists/categoryGroupListsSagas';
import datasetSagas from 'data/datasets/sagas';
import documentSagas from 'data/documents/sagas';
import filterSagas from 'data/filters/sagas';
import institutionSagas from 'data/institutions/sagas';
import institutionLoginsSagas from 'data/institutionLogins/sagas';
import investmentHoldingsSagas from 'data/investmentHoldings/sagas';
import investmentHoldingsV2Sagas from 'data/investmentHoldingsV2/investmentHoldingsV2Sagas';
import persistSagas from 'data/persist/sagas';
import profileSagas from 'data/profile/sagas';
import qcsApiSagas from 'data/apiUtil/apiCall';
import spendingWatchListSagas from 'data/spendingWatchList/sagas';
import subscriptionSagas from 'data/subscriptions/subscriptionsSagas';
import tagSagas from 'data/tags/sagas';
import transactionSagas from 'data/transactions/sagas';
import preferencesSagas from 'data/preferences/sagas';
import rulesSagas from 'data/renameRules/sagas';
import memorizedRulesSagas from 'data/memorizedRules/sagas';
import postponedActionsSagas from 'data/postponedActions/postponedActionsSagas';
import scheduledTransactionsSagas from 'data/scheduledTransactions/scheduledTransactionsSagas';
import jobStatus from 'data/jobStatus/sagas';
import npsSagas from 'data/nps/npsSagas';
import accountBalancesSagas from 'data/accountBalances/sagas';
import payeesSagas from 'data/payees/sagas';
import freeToSpendSagas from 'data/freeToSpend/freeToSpendSagas';
import entitlementsSagas from 'data/entitlements/entitlementsSagas';
import investmentBalancesV2Sagas from 'data/investmentBalancesV2/investmentBalancesV2Sagas';
import investmentPerformanceV2Sagas from 'data/investmentPerformanceV2/investmentPerformanceV2Sagas';
import investmentQuotesV2Sagas from 'data/investmentQuotesV2/investmentQuotesV2Sagas';
import mcRulesSagas from 'data/mcRules/mcRulesSagas';
import goalsSagas from 'data/goals/sagas';
import tripsSagas from 'data/trips/sagas';
import vehiclesSagas from 'data/vehicles/sagas';
import importSagas from 'data/import/importSagas';
import webSocketQCSSagas from 'data/webSocketQCS/webSocketQCSSagas';
import investmentSymbolsSagas from 'data/investmentSymbols/investmentSymbolsSagas';
import appSagas from 'data/app/sagas';
import alertRulesSagas from 'data/alertRules/sagas';
import alertsSagas from 'data/alerts/alertsSagas';

const createSagas = (store) => {

  const sagaTasks = [
    accountSagas,
    accountDiscoverySagas,
    authSagas,
    budgetsSagas,
    budgetItemsSagas,
    categorySagas,
    categoryGroupsSagas,
    categoryGroupListsSagas,
    datasetSagas,
    documentSagas,
    filterSagas,
    institutionSagas,
    institutionLoginsSagas,
    investmentHoldingsSagas,
    investmentHoldingsV2Sagas,
    jobStatus,
    persistSagas,
    profileSagas,
    qcsApiSagas,
    spendingWatchListSagas,
    subscriptionSagas,
    tagSagas,
    transactionSagas,
    preferencesSagas,
    rulesSagas,
    memorizedRulesSagas,
    postponedActionsSagas,
    scheduledTransactionsSagas,
    npsSagas,
    accountBalancesSagas,
    payeesSagas,
    freeToSpendSagas,
    entitlementsSagas,
    investmentBalancesV2Sagas,
    investmentPerformanceV2Sagas,
    investmentQuotesV2Sagas,
    mcRulesSagas,
    goalsSagas,
    tripsSagas,
    vehiclesSagas,
    importSagas,
    webSocketQCSSagas,
    investmentSymbolsSagas,
    appSagas,
    alertRulesSagas,
    alertsSagas,
  ].reduce((tasksAccumulator, sagas) => [...tasksAccumulator, ...sagas.map(store.runSaga)], []);

  return sagaTasks;
};

export default createSagas;
